module["exports"] = [
  "ჯგუფი",
  "და კომპანია",
  "სტუდია",
  "გრუპი"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/company/suffix.js
 ** module id = 632
 ** module chunks = 0
 **/